export const TRANSLATE_PREFIX = 'asset';
export const TRANSLATE_KEY = {
  instructionText: 'instruction_text',
  token: 'token',
  tokenList: 'token_list',
  network: 'network',
};
